@let selection = items();
@let hasLocked = anyItemLocked();
@let hasFolder = anyFolderSelected();
@let isTrashMode = isTrash();
@let multiSelection = selection.length > 1;
@let hasSearchWithMultiSelected = hasSearch() && multiSelection;

@if (selection.length > 0) {
  <div
    class="actions-bar"
    data-testid="actions-bar">
    <div class="selection">
      <p class="selection__label">{{ selectionLabel() }}</p>
      <evc-button
        data-testid="action-clear"
        class="selection__clear"
        [text]="'labels.clearSelection' | translate"
        (click)="broadcast('clearSelection')"
        size="small"
        type="primary"
        frame="none" />
    </div>
    <div class="actions">
      @if (isTrashMode) {
        <evc-button
          data-testid="action-restore"
          *permission="PERMISSIONS.STORAGE_CREATE_UPDATE"
          icon="trash-restore"
          [text]="'actions.restore.action' | translate"
          (click)="broadcast('restoreItems', selection)"
          size="small"
          frame="none"
          type="destructive" />
        <!-- <evc-button *permission="PERMISSIONS.STORAGE_PERMANENT_DELETE"
          icon="trash-delete"
          [text]="'actions.delete.action' | translate"
          (click)="broadcast('deleteItemsPermanently', selection)"
          size="small"
          frame="none"
          type="destructive"
          [wip]
          jiraTicketId="CLOUD-1898"/> -->
      } @else {
        @let canCopy = !hasLocked && !hasFolder && !hasSearchWithMultiSelected;
        @if (canCopy) {
          <evc-button
            data-testid="action-copy"
            *permission="PERMISSIONS.STORAGE_CREATE_UPDATE"
            icon="copy"
            [text]="'actions.copyTo.action' | translate"
            (click)="broadcast('copyItemsTo', selection)"
            size="small"
            type="primary"
            frame="none" />
        }

        @let canMove = !hasLocked && !hasSearchWithMultiSelected;
        @if (canMove) {
          <evc-button
            data-testid="action-move"
            *permission="PERMISSIONS.STORAGE_CREATE_UPDATE"
            icon="file-export"
            [text]="'actions.moveTo.action' | translate"
            (click)="broadcast('moveItemsTo', selection)"
            size="small"
            type="primary"
            frame="none" />
        }
        @if (!hasFolder) {
          <evc-button
            data-testid="action-download"
            *permission="PERMISSIONS.STORAGE_READ"
            icon="download"
            [text]="'actions.download.action' | translate"
            (click)="broadcast('downloadItems', selection)"
            size="small"
            type="primary"
            frame="none" />
        }

        <!-- <evc-button
          icon="share"
          [text]="'actions.share.action' | translate"
          (click)="broadcast('shareItems', selection)"
          size="small"
          type="primary"
          frame="none"
          [wip]
          jiraTicketId="CLOUD-1899"/> -->

        @if (!hasLocked) {
          <evc-button
            data-testid="action-trash"
            *permission="PERMISSIONS.STORAGE_DELETE"
            icon="trash-send"
            [text]="'actions.trash.action' | translate"
            (click)="broadcast('deleteItems', selection)"
            size="small"
            frame="none"
            type="destructive" />
        }
      }
    </div>
  </div>
}
